import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';

import Cookies from './Cookies';
import GDPR from './GDPR';
import s from './PrivacyPages.css';

class PrivacyPagesView extends React.Component {
  render() {
    const { page, runtime } = this.props;
    const hostname = runtime.hostname;

    switch (page) {
      case 'cookies':
        return <Cookies hostname={hostname} />;
      case 'gdpr':
        return <GDPR hostname={hostname}/>;
      default:
        return null;
    }
  }
}

PrivacyPagesView.defaultProps = {
  company: '',
};

PrivacyPagesView.propTypes = {
  page: PropTypes.string.isRequired,
  runtime: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

const mapState = state => ({
  runtime: state.runtime,
});

export default compose(withStyles(s), connect(mapState, null))(
  PrivacyPagesView
);



// WEBPACK FOOTER //
// ./src/components/PrivacyPages/PrivacyPagesView.js